module.exports = __webpack_public_path__ + "static/media/logo-villumfonden.26777873.png";


//////////////////
// WEBPACK FOOTER
// ./src/content/img/logos/logo-villumfonden.png
// module id = 1493
// module chunks = 0